export const CONSULTATION_TIME_ZONE = 'America/New_York';

export function consultationInputValue(iso: string | null): string {
	if (!iso) return '';
	const parts = new Intl.DateTimeFormat('en-US', {
		timeZone: CONSULTATION_TIME_ZONE,
		year: 'numeric',
		month: '2-digit',
		day: '2-digit',
		hour: '2-digit',
		minute: '2-digit',
		hourCycle: 'h23',
	}).formatToParts(new Date(iso));
	const part = (type: string) => parts.find((item) => item.type === type)?.value;
	return `${part('year')}-${part('month')}-${part('day')}T${part('hour')}:${part('minute')}`;
}

// Resolve Eastern wall-clock time independently of the device time zone.
// Reject nonexistent/ambiguous daylight-saving times rather than silently moving them.
export function consultationInputToIso(value: string): string | null {
	if (!value) return null;
	if (!/^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}$/u.test(value)) throw new Error('Select a valid consultation date and time.');
	const wall = Date.parse(`${value}:00Z`);
	if (!Number.isFinite(wall)) throw new Error('Select a valid consultation date and time.');
	const candidates = [4, 5]
		.map((offset) => new Date(wall + offset * 3_600_000).toISOString())
		.filter((iso) => consultationInputValue(iso) === value);
	if (candidates.length !== 1)
		throw new Error('This Eastern Time is unavailable or ambiguous because of daylight saving time. Select another time.');
	return candidates[0];
}
